var _path, _polygon, _path2, _polygon2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 57H21a1 1 0 0 1-1-1 6 6 0 0 1 6-6H38a6 6 0 0 1 6 6A1 1 0 0 1 43 57zM22.13 55H41.87A4 4 0 0 0 38 52H26A4 4 0 0 0 22.13 55zM56.7 21.23l-5-4.94A1 1 0 0 0 51 16H34a1 1 0 0 0-1 1V27a1 1 0 0 0 1 1H51a1 1 0 0 0 .71-.3l5-5.06a1 1 0 0 0 .29-.71A1 1 0 0 0 56.7 21.23zM50.58 26H35V18H50.59l4 3.95z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "54.59 21.95 50.58 26 35 26 35 18 50.59 18 54.59 21.95",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,26H13a1,1,0,0,0-.71.3l-5,5.06a1,1,0,0,0-.29.71,1,1,0,0,0,.3.7l5,4.94A1,1,0,0,0,13,38H30a1,1,0,0,0,1-1V27A1,1,0,0,0,30,26ZM29,36H13.41l-4-4,4-4H29Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "29 28 29 36 13.41 36 9.41 32.05 13.42 28 29 28",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32,17a5,5,0,1,1,2.5-.67A5,5,0,0,1,32,17Zm0-8a3,3,0,0,0-3,3,3,3,0,0,0,6,0A3,3,0,0,0,32,9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34,52H30a1,1,0,0,1-1-1V15.46a1,1,0,0,1,.5-.87,1,1,0,0,1,1,0,3,3,0,0,0,3,0,1,1,0,0,1,1,0,1,1,0,0,1,.5.87V51A1,1,0,0,1,34,52Zm-3-2h2V16.9a5.18,5.18,0,0,1-2,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.ff7f7373e428735b2d3b653554fa77e4.svg";
export { ForwardRef as ReactComponent };